export const TYPES = {
  SCALE: 'scale',
  ONE_OF_MANY: 'one_of_many',
  MANY_OF_MANY: 'many_of_many',
  TABLE: 'table',
  RANGE: 'range',
  EMP_SCALE: 'emp_scale',
  EMP_ONE_OF_MANY: 'emp_one_of_many',
  EMP_MANY_OF_MANY: 'emp_many_of_many',
  EMP_TABLE: 'emp_table',
  MAD_RANGE_TEXT: 'mad_range_text',
  MAD_RANGE_IMAGE: 'mad_range_image',
  MAD_COMP_TEXT: 'mad_comp_text',
  MAD_COMP_IMAGE: 'mad_comp_image',
  DISTRIBUTED_SCALE: 'distributed_scale',
  DISTRIBUTED_SCALE_FOR_PAIR_SELECTION: 'distributed_scale_for_pair_selection',
  RANGES: 'map_range_question'
}

export const EXPIRED_ANSWER_TITLE = 'Время ожидания ответа истекло'

export const DEFAULT_TIMER_EXPIRED_CALLBACK = () => {
  // eslint-disable-next-line no-console
  console.error('Timer error!')
}
